import classNames from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';

import { Text } from '../typography/Text';
import styles from './SupportingText.module.css';

interface SupportingTextProps extends ComponentPropsWithoutRef<typeof Text> {
  isInvalid?: boolean;
}

export const SupportingText = ({
  className,
  isInvalid,
  children,
  ...rest
}: SupportingTextProps) => {
  return (
    <Text
      fontSize="sm"
      className={classNames(
        styles.supportingText,
        isInvalid && styles.invalid,
        className
      )}
      {...rest}
    >
      {children}
    </Text>
  );
};
